import React from 'react'
import EventListItem from './EventListItem'

const EventsList = ({ events }) => (
  <div>
    {events.map(event => <EventListItem key={event._id} data={event} />)}
  </div>
)

export default EventsList